import { call, put, select } from 'redux-saga/effects';
import { getProductOffering } from '@bitComponents/adabyron/catalog';
import { isNumber } from '@bitComponents/utils/common';
import getByAlias from '@gcloud-npm/adabyron.orion.get-by-alias';
import getByProductOffering from '@gcloud-npm/adabyron.orion.get-by-product-offering';
import { CHARACTERISTIC_VALUES_NAMES, CHARACTERISTICS, TEXT_TYPES_CODES } from '../catalogConstants';
import { getProductOfferingTextByType } from '../utils/general';
import { WEB_SERVICES } from './webServices';
import { getProductTypeByProductOfferingTypes } from '../utils/catalog';

const contextStore = state => state.context.data;

const normalizeProductOfferingInfo = (response, modality) => {
  let productOfferingName = getProductOfferingTextByType(response, TEXT_TYPES_CODES.ORDINARY);
  const productOfferingBriefText = getProductOfferingTextByType(response, TEXT_TYPES_CODES.BRIEF);
  const productOfferingShortText = getProductOfferingTextByType(response, TEXT_TYPES_CODES.SHORT);

  if(modality && CHARACTERISTIC_VALUES_NAMES[modality]){
    productOfferingName+= ` ${CHARACTERISTIC_VALUES_NAMES[modality]}`
  }
  
  return {
    productOfferingName,
    productOfferingBriefText,
    productOfferingShortText,
    productOfferingTypes: response.productOfferingTypes,
    productOfferingNormalizedType: getProductTypeByProductOfferingTypes(response.productOfferingTypes),
    productOfferingId: response.id,
  };
};

export function* getProductOfferingData(params) {
  const { normalizeHttpErrors, reduxUpdate, idPO, modality } = params;
  try {
    const { successUpdate } = reduxUpdate;
    const context = yield select(contextStore);
    const response = yield call(getProductOffering, { idPO }, context);
    const poInfo = normalizeProductOfferingInfo(response, modality);
    yield put(successUpdate(poInfo));
  } catch (error) {
    const { errorUpdate } = reduxUpdate;

    const errorNormalized = yield call(normalizeHttpErrors, WEB_SERVICES.GET_PRODUCT_OFFERING, error);
    if (errorUpdate) {
      yield put(errorUpdate(errorNormalized));
    }

    return null;
  }
}

const normalizeProductOfferingOrionInfo = (response) => {
  let finalPrice;
  let priceBeforeDiscounts;
  let promotionText;
  let oneTimeHiringQuote;
  let priceUnit;
  let legal;
  let name;
  let provisionalAgreementUrl;

  const { baseOffer, data, offers, productOffering } = response;
  if(isNumber(baseOffer?.price)){
    finalPrice = baseOffer.price;
  }
  if(baseOffer?.legal){
    ({ legal } = baseOffer);
  }
  if(data?.fields?.["DATAMAP_PRODUCTO"]?.fields){
    const { nombreComercial, textPrecontrato, unidad, CuotaAlta } = data.fields["DATAMAP_PRODUCTO"].fields;
    name = nombreComercial;
    provisionalAgreementUrl = textPrecontrato;
    priceUnit = unidad;
    oneTimeHiringQuote = CuotaAlta
  } else if(data?.fields?.["DATAMAP_TV"]?.fields){
    const { nombreComercial, textPrecontrato, unidad, CuotaAlta } = data.fields["DATAMAP_TV"].fields;
    name = nombreComercial;
    provisionalAgreementUrl = textPrecontrato;
    priceUnit = unidad;
    oneTimeHiringQuote = CuotaAlta
  }

  if(offers && Object.keys(offers).length === 1 && offers[Object.keys(offers)[0]]){
    const { price, data } = offers[Object.keys(offers)[0]];
    if(isNumber(price) && price !== finalPrice){
      priceBeforeDiscounts = finalPrice;
      finalPrice = price;
      if(data?.fields?.bandaInfo){
        promotionText = data.fields.bandaInfo;
      }
    }
  }

  let oneTimeFinalPrice = null;
  
  if (oneTimeHiringQuote && oneTimeHiringQuote !== '0') {
    oneTimeFinalPrice = parseInt(oneTimeHiringQuote);
  }

  const result = {
    productOffering: parseInt(productOffering),
    name,
    pricesInfo: {
      recurringCharges: {
        finalPrice,
        priceBeforeDiscounts,
        promotionText,
        priceUnit,
      },
      oneTimeCharges: {
        finalPrice: oneTimeFinalPrice,
      }
    },
    legal,
    provisionalAgreementUrl,
  }

  return result;
};

const normalizeProductOfferingOrionInfoTelco = (response) => {
  let finalPrice;
  let priceBeforeDiscounts;
  let promotionId;
  let promotionText;
  let priceUnit;
  let legal;
  let name;
  let provisionalAgreementUrl;
  let buyProcessUrl;

  const { baseOffer, data, offers, productOffering } = response;
  if(baseOffer?.price){
    finalPrice = baseOffer.price;
  }
  if(baseOffer?.data?.fields?.["OFFER_TELCO_INFO"]?.fields){
    const { legalTerms, precontract } = baseOffer.data.fields["OFFER_TELCO_INFO"].fields;
    legal = legalTerms;
    provisionalAgreementUrl = precontract;
  }

  if(offers && Object.keys(offers).length === 1 && offers[Object.keys(offers)[0]]){
    const { price, data, promoId } = offers[Object.keys(offers)[0]];
    if(isNumber(price) && price !== finalPrice){
      priceBeforeDiscounts = finalPrice;
      finalPrice = price;
      if(data?.fields?.bandaInfo){
        promotionText = data.fields.bandaInfo;
      }
      if(promoId){
        promotionId = promoId;
      }
      if(data?.fields?.legalCorto){
        legal += data.fields.legalCorto;
      }
    }
  }
  if(data?.fields?.["DATAMAP_PRODUCTO_GP_BAF"]?.fields?.nombreComercial){
    name = data.fields["DATAMAP_PRODUCTO_GP_BAF"].fields.nombreComercial;
    priceUnit = data.fields["DATAMAP_PRODUCTO_GP_BAF"].fields.unidad;
  }else if(data?.fields?.["DATAMAP_PRODUCTO"]?.fields?.nombreComercial){
    name = data.fields["DATAMAP_PRODUCTO"].fields.nombreComercial;
    priceUnit = data.fields["DATAMAP_PRODUCTO"].fields.unidad;
  }

  if(data?.fields?.["DATAMAP_PRODUCTO"]?.fields?.urlProdCompra){
    buyProcessUrl = data.fields["DATAMAP_PRODUCTO"].fields.urlProdCompra;
  }

  const result = {
    productOffering: parseInt(productOffering),
    name,
    pricesInfo: {
      recurringCharges: {
        finalPrice,
        promotionId,
        priceBeforeDiscounts,
        promotionText,
        priceUnit,
      },
    },
    legal,
    provisionalAgreementUrl,
    buyProcessUrl,
  }

  return result;
};

export function* getProductOfferingOrion(params){
  const { normalizeHttpErrors, showError, alias, productOfferingId } = params;
  try {
    const context = yield select(contextStore);
    let response;
    let productInfo;
    if(alias){
      response = yield call(getByAlias, { alias, context });
      productInfo = normalizeProductOfferingOrionInfo(response);
    } else if(productOfferingId){
      response = yield call(getByProductOffering, { alias: productOfferingId, context });
      productInfo = normalizeProductOfferingOrionInfoTelco(response);
    }
    return productInfo;
  } catch (error) {

    const errorNormalized = yield call(normalizeHttpErrors, WEB_SERVICES.GET_PRODUCT_OFFERING_ORION, error);
    if (showError) {
      yield put(showError(errorNormalized));
    }

    return null;
  }
}